export default "__VITE_ASSET__LRUXwFQc__"